module.exports = __webpack_public_path__ + "img/login_guide2.b3c98640.png";